import {createAction, props} from '@ngrx/store';
import {ProductManagementErrorInterface} from './product-management-error';

export const uncaughtError = createAction(
  '[Error Handling] Unhandled error',
  props<{error: ProductManagementErrorInterface}>()
);

export const unrecoverableError = createAction(
  '[Error Handling] Unrecoverable error',
  props<{error: ProductManagementErrorInterface}>()
);

export const logError = createAction(
  '[Error Handling] Caught error',
  props<{error: ProductManagementErrorInterface}>()
);
